import { fork } from 'redux-saga/effects'

import Profile from './modules/profile/sagas'
import User from './modules/user/sagas'
import Professional from './modules/professional/sagas'
import Coupon from './modules/coupon/sagas'
import Customers from './modules/customers/sagas'
import Module from './modules/module/sagas'
import Notification from './modules/notification/sagas'

export default function * root () {
  yield fork(Profile)
  yield fork(User)
  yield fork(Professional)
  yield fork(Coupon)
  yield fork(Customers)
  yield fork(Module)
  yield fork(Notification)
}
